import { render, staticRenderFns } from "./AutenticacaoDoisFatores.vue?vue&type=template&id=98a2f392&scoped=true&"
import script from "./AutenticacaoDoisFatores.vue?vue&type=script&lang=js&"
export * from "./AutenticacaoDoisFatores.vue?vue&type=script&lang=js&"
import style0 from "./AutenticacaoDoisFatores.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AutenticacaoDoisFatores.vue?vue&type=style&index=1&id=98a2f392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a2f392",
  null
  
)

export default component.exports